export function parsePrice({
  number,
  decimals = 2,
  decimalChar = ',',
  thousandChar = '.',
  preserveDecimals = false,
}) {
  let res = number;

  res = parseFloat(res).toFixed(decimals);
  res = res.replace('.', decimalChar);

  const splitNum = res.split(decimalChar);

  splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandChar);
  if (preserveDecimals) {
    return splitNum.join(decimalChar);
  }
  return splitNum[1] !== '00' ? splitNum.join(decimalChar) : splitNum[0];
}
